import { useMutation, useQueryClient } from '@tanstack/react-query';

import type {
  CreateChatTriggerRequest,
  UpdateChatTriggerRequest,
} from '@nucleus-commerce/api-client/admin';

import { chatSettingsApi } from '../api/chat-settings-api';

import { chatSettingsKeys } from './chat-settings-keys';

export function useTriggerMutations(storeId: string) {
  const queryClient = useQueryClient();
  const refresh = () =>
    queryClient.invalidateQueries({ queryKey: chatSettingsKeys.triggers(storeId) });

  const create = useMutation({
    mutationFn: (body: CreateChatTriggerRequest) => chatSettingsApi.createTrigger(storeId, body),
    meta: { successMessage: 'chatSettings:toasts.triggerSaved', silentError: true },
    onSuccess: refresh,
  });
  const update = useMutation({
    mutationFn: ({ id, body }: { id: string; body: UpdateChatTriggerRequest }) =>
      chatSettingsApi.updateTrigger(storeId, id, body),
    meta: { successMessage: 'chatSettings:toasts.triggerSaved', silentError: true },
    onSuccess: refresh,
  });
  // the list's on/off switch: no toast, the switch is the feedback
  const toggle = useMutation({
    mutationFn: ({ id, enabled }: { id: string; enabled: boolean }) =>
      chatSettingsApi.updateTrigger(storeId, id, { enabled }),
    onSuccess: refresh,
  });
  const remove = useMutation({
    mutationFn: (id: string) => chatSettingsApi.deleteTrigger(storeId, id),
    meta: { successMessage: 'chatSettings:toasts.triggerDeleted' },
    onSuccess: refresh,
  });
  return { create, update, toggle, remove };
}
